var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white ml-4",attrs:{"id":"dark-switch"}},[_c('toggle-button',{attrs:{"value":_vm.dark_mode,"labels":{checked: '\uf186', unchecked: '\uf185'},"color":{checked: '#e9ecef', unchecked: '#495057'},"switch-color":{checked: '#495057', unchecked: '#e9ecef'}},on:{"change":_vm.toggleDarkMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }